import { render, staticRenderFns } from "./login-redirect.vue?vue&type=template&id=83b12388&"
import script from "./login-redirect.vue?vue&type=script&lang=js&"
export * from "./login-redirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports